import React from "react";
import './InvestFooter.css';
import InvestMenu from "../InvestMenu/InvestMenu";
function InvestFooter(props) {
    return (
        <footer className="InvestFooter">
        <div className="InvestFooterIn">
            <InvestMenu styleMain='InvestFooterMenu' active='InvestFooterActiveLink' inactive='InvestFooterActiveLinkNot'
            Name01={props.PrerenderTexts['InvestHeader0000 '] ? props.PrerenderTexts['InvestHeader0000 '] : '*Fxbitcoin.org' }
            Name02={props.PrerenderTexts['InvestHeader0005 '] ? props.PrerenderTexts['InvestHeader0005 '] : '*ВОЙТИ НА СЧЕТ' }
            Name03={props.PrerenderTexts['InvestHeader0010 '] ? props.PrerenderTexts['InvestHeader0010 '] : '*ПЕРЕХОД НА СЛЕД. ЭТАП' }
            Name04={props.PrerenderTexts['InvestHeader0015 '] ? props.PrerenderTexts['InvestHeader0015 '] : '*FAQ' }
            Name05={props.PrerenderTexts['InvestHeader0020 '] ? props.PrerenderTexts['InvestHeader0020 '] : '*РЕГИСТРАЦИЯ' }
                        lang={props.lang}
            />
            <div className="InvestFooterCopyRight">©2007-{(new Date()).getFullYear()} BitcoinForex </div>
        </div>
        </footer>
    )}

export default InvestFooter



